import { render, staticRenderFns } from "./certificate-choice.vue?vue&type=template&id=f0cff9e4&"
import script from "./certificate-choice.vue?vue&type=script&lang=js&"
export * from "./certificate-choice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports